import axiosInstance from '@/utils/httpUtil'
import { setting } from '@/setting'

const adminBaseUrl = setting.adminBaseUrl

export const courseApi = {
  createCategory: ({name, categoryTypeId}) => {
    return axiosInstance.post(
      `${adminBaseUrl}/category`,
      {
        "name": name,
        "categoryTypeId": categoryTypeId
      }
    )
  },
    // 删除目录
    deleteCategory: (id) => {
        return axiosInstance.delete(
          `${adminBaseUrl}/category/${id}`
        )
      },
    // 更新目录
    updateCategory: ({id, name}) => {
        return axiosInstance.put(
          `${adminBaseUrl}/category/${id}`,
          { "name": name }
        )
      },
  // 上传课程
  uploadCourse: ({ courseTopicId, lessonName, videoFile }) => {
    return axiosInstance.post(
      `${adminBaseUrl}/videoCourse`,
      videoFile,
      {
        params: {
          courseTopicId,
          lessonName
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },

  // 更新课程
//   updateCourse: ({ id, courseTopicId, lessonName, videoFile }) => {
//     const config = {
//       params: {
//         courseTopicId,
//         lessonName
//       },
//       headers: {
//         'Content-Type': 'multipart/form-data'
//       }
//     }

//     if (videoFile) {
//       config.headers = {
//         'Content-Type': 'multipart/form-data'
//       }
//     }

//     return axiosInstance.put(
//       `${adminBaseUrl}/videoCourse/${id}`,
//       videoFile || null,
//       config
//     )
//   },

  // 取课程列表
  getCourseTopicList: ({ categoryIds }) => {
    // 构建参数对象，将 categoryIds 数组转换为多个同名参数
    const params = new URLSearchParams()
    if (categoryIds && categoryIds.length > 0) {
      categoryIds.forEach(id => {
        params.append('categoryIds', id)
      })
    }

    return axiosInstance.get(
      `${adminBaseUrl}/courseTopics`,
      { params }
    )
  },

  // 获取课程分类目录列表
  getCourseCategories: () => {
    return axiosInstance.get(
      `${adminBaseUrl}/courseCategories`
    )
  },

  // 删除课程主題
  deleteCourseTopic: (id) => {
    console.log('id = ', id);
    return axiosInstance.delete(
      `${adminBaseUrl}/courseTopic/${id}`
    )
  },

  // 创建课程主题
  createCourseTopic: ({ categoryId, topicName, coverImageFile }) => {
    const formData = new FormData();
    formData.append('categoryId', categoryId);
    formData.append('topicName', topicName);
    formData.append('coverImageFile', coverImageFile);

    return axiosInstance.post(
      `${adminBaseUrl}/courseTopic`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).catch(error => {
      // 統一處理錯誤
      const errorMessage = error.response?.data?.message || error.message || '未知错误';
      throw new Error(errorMessage);
    });
  },

  // 更新课程主题名称
  updateCourseTopic: ({ id, topicName }) => {
    return axiosInstance.put(
      `${adminBaseUrl}/courseTopic/${id}`,
      { topicName }
    )
  },

  // 获取主题下的所有课程
  getTopicLessons: (topicId) => {
    return axiosInstance.get(
      `${adminBaseUrl}/courseTopic/${topicId}/lessons`
    )
  },

  // 删除课程
  deleteLesson: (lessonId) => {
    return axiosInstance.delete(
      `${adminBaseUrl}/lesson/${lessonId}`
    )
  },

  // 更新主题信息（包括名称、描述和封面图）
  updateTopicInfo: (topicId, formData) => {
    return axiosInstance.put(
      `${adminBaseUrl}/courseTopic/${topicId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },

  // 创建课程章节
  createLesson: ({ courseTopicId, lessonName, description, videoFile }) => {
    return axiosInstance.post(
      `${adminBaseUrl}/videoCourse`,
      videoFile,
      {
        params: {
          courseTopicId,
          lessonName,
          description
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },

  // 获取阿里云STS单档上传链接
  getUploadStsUrl: (type, fileExtension) => {
    return axiosInstance.get(
      `${adminBaseUrl}/file/uploadStsToken`,
      {
        params: {
          type,
          fileExtension
        }
      }
    )
  },

  // 获取阿里云Multipart分片上传链接
  getUploadMultipartUrl: ({type, fileExtension, courseTopicId, lessonId, lessonName, description, sortOrder}) => {
    return axiosInstance.get(
      `${adminBaseUrl}/file/multipartUploadStsToken`,
      {
        params: {
          type,
          fileExtension,
          courseTopicId,
          lessonId,
          lessonName,
          description,
          sortOrder
        }
      }
    )
  },

  // 更新课程章节
  updateLesson: ({ id, courseTopicId, lessonName, description, videoFile, sortOrder }) => {
    console.log('API 调用参数：', { id, courseTopicId, lessonName, description });

    return axiosInstance.put(
      `${adminBaseUrl}/videoCourse/${id}`,
      videoFile || new FormData(),
      {
        params: {
          courseTopicId,
          lessonName,
          description,
          sortOrder
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(response => {
      console.log('API 响应：', response);
      return response;
    }).catch(error => {
      console.error('API 错误：', error.response || error);
      throw error;
    });
  },

  // 删除课程章节
  deleteCourseLesson: (id) => {
    return axiosInstance.delete(
        `${adminBaseUrl}/videoCourse/${id}`
      );
  }
} 